import { PID_AGITATORS_SYMBOLS } from './PidAgitatorsSymbols'
import { PID_APPARATUS_ELEMENTS_SYMBOLS } from './PidApparatusElementsSymbols'
import { PID_CENTRIFUGES_SYMBOLS } from './PidCentrifugesSymbols'
import { PID_COMPRESSORS_ISO_SYMBOLS } from './PidCompressorsIsoSymbols'
import { PID_COMPRESSORS_SYMBOLS } from './PidCompressorsSymbols'
import { PID_CRUSHERS_GRINDING_SYMBOLS } from './PidCrushersGrindingSymbols'
import { PID_ENGINES_SYMBOLS } from './PidEnginesSymbols'
import { PID_FEEDERS_SYMBOLS } from './PidFeedersSymbols'
import { PID_FILTERS_SYMBOLS } from './PidFiltersSymbols'
import { PID_FITTINGS_SYMBOLS } from './PidFittingsSymbols'
import { PID_FLOW_SENSORS_SYMBOLS } from './PidFlowSensorsSymbols'
import { PID_HEAT_EXCHANGERS_SYMBOLS } from './PidHeatExchangersSymbols'
import { PID_MISC_SYMBOLS } from './PidMiscSymbols'
import { PID_MIXERS_SYMBOLS } from './PidMixersSymbols'
import { PID_PIPING_SYMBOLS } from './PidPipingSymbols'
import { PID_PUMPS_DIN_SYMBOLS } from './PidPumpsDinSymbols'
import { PID_PUMPS_ISO_SYMBOLS } from './PidPumpsIsoSymbols'
import { PID_PUMPS_SYMBOLS } from './PidPumpsSymbols'
import { PID_SEPARATORS_SYMBOLS } from './PidSeparatorsSymbols'
import { PID_SHAPING_MACHINES_SYMBOLS } from './PidShapingMachinesSymbols'
import { PID_VESSELS_SYMBOLS } from './PidVesselsSymbols'

export const GENERATED_SYMBOL_SETS = [
  PID_AGITATORS_SYMBOLS,
  PID_APPARATUS_ELEMENTS_SYMBOLS,
  PID_CENTRIFUGES_SYMBOLS,
  PID_COMPRESSORS_ISO_SYMBOLS,
  PID_COMPRESSORS_SYMBOLS,
  PID_CRUSHERS_GRINDING_SYMBOLS,
  PID_ENGINES_SYMBOLS,
  PID_FEEDERS_SYMBOLS,
  PID_FILTERS_SYMBOLS,
  PID_FITTINGS_SYMBOLS,
  PID_FLOW_SENSORS_SYMBOLS,
  PID_HEAT_EXCHANGERS_SYMBOLS,
  PID_MISC_SYMBOLS,
  PID_MIXERS_SYMBOLS,
  PID_PIPING_SYMBOLS,
  PID_PUMPS_DIN_SYMBOLS,
  PID_PUMPS_ISO_SYMBOLS,
  PID_PUMPS_SYMBOLS,
  PID_SEPARATORS_SYMBOLS,
  PID_SHAPING_MACHINES_SYMBOLS,
  PID_VESSELS_SYMBOLS,
] as const
